import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from '../../LocalStorageService';
import { Router } from '@angular/router';
import { JwtDecodeService } from '../others/JWTDecodeService';
import { MainContainerService } from 'src/app/service/main-container.service';
import { Subscription } from 'rxjs';
import { UserLogInDetail } from 'src/app/model/user-log-in-detail';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ToastService } from 'src/app/service/toast.service';
import { ChooseLocationDialogComponent } from '../../choose-location-dialog/choose-location-dialog.component';
import { getWindow } from 'ssr-window';
import { logOutApp } from 'src/myfunc';
import { AppConfigService } from 'src/app/service/Configuration/app-config.service';
import { DeviceDetectorService } from '../../device-detector.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  signIn: any;
  userLogInDetail: UserLogInDetail;
  userSubscription: Subscription;



  constructor(private readonly jWTDecodeService: JwtDecodeService, private persistenceService: LocalStorageService, private router: Router,
    private readonly dialog: MatDialog,
    private readonly toastService: ToastService,
    private readonly mainContainerService: MainContainerService,
    private readonly appConfig: AppConfigService,
    private deviceDetector: DeviceDetectorService
  ) {

  }
  ngAfterViewInit() {
    let cnt = 1;
    if (this.persistenceService.get("allEMails") == undefined || this.persistenceService.get("allEMails") == null) {
      cnt = 1
    }
    else {
      cnt = this.persistenceService.get("allEMails").split(",").length
    }

    if (!this.appConfig.setting.loginLogoutUrl.includes("localhost")) {


      if (this.persistenceService.get("access_token") == undefined || this.persistenceService.get("access_token") == null || this.persistenceService.get("access_token") == "NA" || !this.jWTDecodeService.isTokenValid(this.persistenceService.get("access_token"))) {
        if (this.deviceDetector.isNativeApp()) {
          // Native Android app - use native login
          console.log("Native Android app detected - using native login");
          // Native login will be handled by the Android app
        }

        else {
          // Browser (including Android browser) - use Angular login page
          window.location.href = this.appConfig.setting.loginLogoutUrl + "signin?cnt=" + cnt + "&source=" + window.location.origin + "/";
        }
      }
      else {
        const userResp = this.jWTDecodeService.decodeToken(this.persistenceService.get("access_token"));
        if (window.location.hostname.includes("localhost")) {
          console.log("USERS:" + JSON.stringify(userResp));
        }
        // this.persistenceService.set('access_token', tokens.accessToken.accessToken)
        this.persistenceService.set('id_token', userResp.id_token)
        if (window.location.hostname.includes("localhost"))
          console.log("Access Token : " + this.persistenceService.get('access_token'))
        this.persistenceService.set('modulesAllowed', JSON.stringify(userResp.groups))
        this.persistenceService.set('noOfDaysAllowed', userResp.noOfDays.toString())
        if (!this.userLogInDetail) {
          this.userLogInDetail = new UserLogInDetail();
        }
        this.userLogInDetail.userId = userResp.sub;
        this.userLogInDetail.userEmail = userResp.email;
        this.userLogInDetail.userName = userResp?.user_name;
        this.persistenceService.set('userId', userResp?.sub)

        this.persistenceService.set('userId', userResp.sub)
        this.persistenceService.set('userEmail', userResp.email)

        this.persistenceService.set('userEmpCode', JSON.stringify(userResp?.empCode)); // added for expense management approver empCode
        this.persistenceService.set('userName', this.userLogInDetail.userName) // added for credit note by user
        this.persistenceService.set('userDetail', JSON.stringify(this.userLogInDetail))

        if (window.location.hostname.includes("localhost")) {
          console.log("User Details : " + this.persistenceService.get('userDetail'))
        }

        this.userSubscription = this.mainContainerService.setLoginTimeOfUser().subscribe((data: any) => {
          if (data.status == "Not Allowed") {
            this.persistenceService.set("AllowedAccess", "No");
            this.toastService.showErrorToast("You are not authorized to access this application")

            this.persistenceService.set('access_token', null)
            if (this.deviceDetector.isNativeApp()) {
              console.log("Logout2 - Native app")
              logOutApp()
            }

            else
              window.location.href = window.location.origin + "/"
          }
          else {
            this.persistenceService.set("AllowedAccess", "Yes");
            this.openChooseLocDialog();
          }

        });
      }
      if (this.persistenceService.get('userDetail') != null || this.persistenceService.get('userDetail') != undefined) {
        if (this.deviceDetector.isNativeApp()) {
          console.log("Native app user detail check")
        }
      }
    }
  }
  ngOnInit() {
  }
  openChooseLocDialog() {
    let dialogConfig: MatDialogConfig = {
      disableClose: true,
      autoFocus: true,
      panelClass: 'full-screen-modal',
      maxWidth: '100%',
      height: '100%',
      width: '100%',
      data: this.userLogInDetail
    }
    let dialogRef = this.dialog.open(ChooseLocationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data != null && data != undefined) {
          // this.router.navigateByUrl("dashboard")
          window.location.reload()
        }
      });
  }

}
